import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Container,
  TextField,
  Divider,
  Stack,
  Grid,
  CircularProgress,
  TextareaAutosize,
  InputLabel,
  Typography,
  IconButton,
  Tooltip,
  Alert,
  // Autocomplete,
} from "@common-ui/ui";
import { ModalContext } from "../../components/BrowserAlert/modalContext";
import { useParams, useHistory } from "react-router-dom";
import {
  updateMaintenancePlan,
  getMaintenancePlan,
  createGroup,
  createItem,
  updateGroup,
  updateItem,
} from "../../services";
import AlertDialog from "./AlertDialog";
import { useDispatch, useSelector } from "react-redux";
// import Address from "./Address";
import { AddCircle } from "@mui/icons-material";

import { setGroups } from "../../actions";

import MaintenanceGroup from "./Group";

import Heading from "./Heading";
let GROUP = {
  type: "",
  plan: "",
  name: "",
  description: "",
  group_type: "",
  group_recurrence: "",
  item_assignee: "",
};

export const EditMaintenancePlansForm = () => {
  let { handleModal } = React.useContext(ModalContext);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const { groups, isEdited } = useSelector((state) => state["maintenancePlan"]);
  const [info, setInfo] = useState(true);
  let router = useHistory();
  let params = useParams();
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function init() {
    if (!params.id) return;
    try {
      let payload = await getMaintenancePlan(params.orgId, params.id);
      if (!payload) return;
      const {
        // create_date,
        description,
        notes,
        // owner,
        revision,
        // system_id,
        title,
        groups,
        // update_date,
      } = payload;
      formik.resetForm({
        values: {
          description: description || "",
          notes: notes || "",
          revision: revision || "",
          title: title || "",
        },
      });
      // formik.setFieldValue("title", title || "");
      // formik.setFieldValue("revision", revision || "");
      // formik.setFieldValue("description", description || "");
      // formik.setFieldValue("notes", notes || "");
      dispatch(setGroups(groups));
    } catch (error) {}
    // setMaintenanceGroup(groups);
    setIsLoading(false);
  }

  const formik = useFormik({
    initialValues: {
      title: "",
      revision: "",
      description: "",
      notes: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().trim().max(255).required("Title is required"),
      revision: Yup.string().trim(),
      description: Yup.string().trim(),
      notes: Yup.string().trim(),
    }),
    onSubmit: () => {
      async function submit() {
        try {
          await handleSubmitGroups();

          // return;
          // console.log("formik", formik);
          const { title, revision, description, notes } = formik.values;
          let attributes = { title, revision, description, notes };
          try {
            await onSubmit(attributes);
            setOpen(true);
          } catch (error) {
            // console.log(error);
            // alert(error.message);
            handleModal(error.message, "Error");
            formik.setSubmitting(false);
          }
        } catch (error) {
          // return alert("Please enter name and type for groups!");
          return handleModal("Please enter name and type for groups!", "Error");
        }
      }
      submit();
    },
  });

  const handleSubmitGroups = async () => {
    return new Promise(async (resolve, reject) => {
      if (!groups.length) return resolve(true);
      console.log(groups);
      try {
        Array.from(groups).forEach(async (group) => {
          if (group.system_id) {
            // Update group
            try {
              if (group.isEdited) {
                let payload = await updateGroup(
                  params.orgId,
                  group,
                  params.id,
                  group.system_id
                );
                console.log("Updated group", payload);
              }
              if (group.items) {
                // check items
                Array.from(group.items).forEach(async (item) => {
                  if (item.system_id) {
                    // update item
                    let itemPayload = await updateItem(
                      params.orgId,
                      { ...item, plan: params.id },
                      params.id,
                      group.system_id,
                      item.system_id
                    );
                    console.log("Item updated", itemPayload);
                  } else {
                    console.log("New Createtion", item);
                    // create item
                    let itemPayload = await createItem(
                      params.orgId,
                      { ...item, plan: params.id },
                      params.id,
                      group.system_id
                    );
                    console.log("create item", itemPayload);
                  }
                });
              } else {
                // do nothing
                return;
              }
              // console.log("create group", payload);
            } catch (error) {
              reject(error);
            }
          } else {
            // Create group
            try {
              let payload = await createGroup(params.orgId, group, params.id);
              // console.log("create group", payload);
              let groupId = payload.system_id;
              if (group.items) {
                // check items
                Array.from(group.items).forEach(async (item) => {
                  if (item.system_id) {
                    // update item
                    let itemPayload = await updateItem(
                      params.orgId,
                      { ...item, plan: params.id },
                      params.id,
                      groupId,
                      item.system_id
                    );
                    console.log("Item updated", itemPayload);
                  } else {
                    // create item
                    let itemPayload = await createItem(
                      params.orgId,
                      item,
                      params.id,
                      groupId
                    );
                    console.log("create item", itemPayload);
                  }
                });
              } else {
                // do nothing
                return;
              }
            } catch (error) {
              reject(error);
            }
          }
        });
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  };

  const onSubmit = async (attributes) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const payload = await updateMaintenancePlan(
          params.orgId,
          attributes,
          params.id
        );
        resolve({ payload: payload });
      } catch (error) {
        reject(error);
      }
    });
  };
  const handleCreateGroup = async () => {
    try {
      let attributes = GROUP;
      let planId = params.id;
      let payload = await createGroup(params.orgId, attributes, planId);
      console.log(payload);
    } catch (error) {}
  };

  const handleClose = () => {
    router.push({
      pathname: `/maintenance-plans`,
    });
    setOpen(false);
  };

  return isLoading ? (
    <Box
      component="main"
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        minHeight: "100%",
        ".MuiDataGrid-virtualScroller": {
          marginTop: "40px !important",
        },
        // bgcolor: "background.paper",
      }}
    >
      <Container maxWidth="md" component="main">
        <Box sx={{ my: 3 }}>
          <CircularProgress />
        </Box>
      </Container>
    </Box>
  ) : (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          // bgcolor: "background.paper",
        }}
      >
        <Container maxWidth="md" component="main">
          <Stack direction="column" sx={{ maxWidth: { md: 800 } }}>
            <Grid
              container
              spacing={2}
              style={{
                paddingLeft: "0 !important",
                paddingRight: "0 !important",
              }}
            >
              <Heading />
            </Grid>
            <Divider sx={{ mb: 1, mt: 2 }} />
          </Stack>
          <form onSubmit={formik.handleSubmit}>
            <Stack direction="column" sx={{ maxWidth: { md: 800 } }}>
              <Grid
                container
                spacing={2}
                style={{
                  paddingLeft: "0 !important",
                  paddingRight: "0 !important",
                }}
              >
                <Grid item md={4} xs={12}>
                  <div>
                    <InputLabel>
                      <span>
                        <svg
                          width="16px"
                          height="16px"
                          viewBox="0 0 16 16"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g fillRule="evenodd">
                            <polygon
                              id="Shape"
                              fill="#EE2E24"
                              fillRule="nonzero"
                              points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                            ></polygon>
                          </g>
                        </svg>
                      </span>
                      Title
                    </InputLabel>
                    <TextField
                      sx={{ mt: 1 }}
                      size="small"
                      autoComplete="off"
                      error={Boolean(
                        formik.touched.title && formik.errors.title
                      )}
                      fullWidth
                      helperText={formik.touched.title && formik.errors.title}
                      placeholder="Type"
                      margin="normal"
                      name="title"
                      onBlur={formik.handleBlur}
                      onChange={(e) => formik.handleChange(e)}
                      value={formik.values.title}
                      variant="outlined"
                    />
                  </div>
                </Grid>
                <Grid item md={4} xs={12}>
                  <div>
                    <InputLabel>Revision</InputLabel>
                    <TextField
                      sx={{ mt: 1 }}
                      size="small"
                      autoComplete="off"
                      error={Boolean(
                        formik.touched.revision && formik.errors.revision
                      )}
                      fullWidth
                      helperText={
                        formik.touched.revision && formik.errors.revision
                      }
                      placeholder="Type"
                      margin="normal"
                      name="revision"
                      onBlur={formik.handleBlur}
                      onChange={(e) => formik.handleChange(e)}
                      type="revision"
                      value={formik.values.revision}
                      variant="outlined"
                    />
                  </div>
                </Grid>
                <Grid item md={4} xs={12}>
                  <div>
                    <InputLabel>Description</InputLabel>
                    <TextField
                      sx={{ mt: 1 }}
                      size="small"
                      autoComplete="off"
                      error={Boolean(
                        formik.touched.description && formik.errors.description
                      )}
                      fullWidth
                      helperText={
                        formik.touched.description && formik.errors.description
                      }
                      placeholder="Type"
                      margin="normal"
                      name="description"
                      onBlur={formik.handleBlur}
                      onChange={(e) => formik.handleChange(e)}
                      value={formik.values.description}
                      variant="outlined"
                    />
                  </div>
                </Grid>
                <Grid item md={12} xs={12}>
                  <div>
                    <InputLabel>Notes / Comments</InputLabel>
                    <TextField
                      sx={{ mt: 1 }}
                      size="small"
                      error={Boolean(
                        formik.touched.notes && formik.errors.notes
                      )}
                      fullWidth
                      helperText={formik.touched.notes && formik.errors.notes}
                      placeholder="Type"
                      margin="normal"
                      onChange={(e) => formik.handleChange(e)}
                      value={formik.values.notes}
                      onBlur={formik.handleBlur}
                      InputProps={{
                        inputComponent: TextareaAutosize,
                        inputProps: { minRows: 4 },
                      }}
                      name="notes"
                      variant="outlined"
                    />
                  </div>
                </Grid>
                <Grid item md={12} xs={12}>
                  {/* <Divider sx={{ mb: 2, mt: 1 }} /> */}
                  <Typography variant="h4" gutterBottom>
                    Maintenance Groups
                  </Typography>
                  {(info && !groups) || (info && groups && !groups.length) ? (
                    <Alert
                      color="info"
                      onClose={() => setInfo(false)}
                      severity="info"
                      variant="standard"
                    >
                      You have 0 maintenance group. Use the button below to add
                      a new maintenance plan group.
                    </Alert>
                  ) : (
                    ""
                  )}
                  {/* Maintenance Group */}
                  {Array(groups).length
                    ? groups.map((item, index) => {
                        return (
                          <div key={index} style={{ marginBottom: 16 }}>
                            <MaintenanceGroup
                              handleCreateGroup={handleCreateGroup}
                              item={{ ...item, display_order: index }}
                              index={index}
                              groups={groups}
                            />
                          </div>
                        );
                      })
                    : // <MaintenanceGroup item={GROUP} index={0} />
                      "No data"}
                  <Stack
                    sx={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Tooltip title="Add a New Maintenance Group">
                      <IconButton
                        color="primary"
                        aria-label="add task"
                        component="span"
                        onClick={() => {
                          // console.log([...groups, GROUP]);
                          // handleCreateGroup();
                          return dispatch(setGroups([...groups, GROUP]));
                        }}
                      >
                        <AddCircle />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </Grid>
              </Grid>
            </Stack>

            <Stack sx={{ maxWidth: { md: 800 } }}>
              <Divider sx={{ mb: 1, mt: 2 }} />

              <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent="flex-end"
                spacing={{ xs: 1, md: 2 }}
                sx={{ py: 2 }}
              >
                <div>
                  <Button
                    color="primary"
                    // disabled={formik.isSubmitting}
                    fullWidth
                    size="large"
                    onClick={() => router.goBack()}
                    // type="submit"
                    variant="text"
                  >
                    Cancel
                  </Button>
                </div>
                <div>
                  <Button
                    color="primary"
                    disabled={
                      !(
                        (isEdited || formik.dirty) &&
                        formik.isValid &&
                        !formik.isSubmitting
                      )
                      // ||
                      // !(formik.isValid && !formik.isSubmitting && formik.dirty)
                    }
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Save
                  </Button>
                </div>
              </Stack>
            </Stack>
          </form>
        </Container>
      </Box>
      <AlertDialog handleClose={handleClose} open={open} edit />
    </>
  );
};
